"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegExp = exports.truncateString = exports.validateValue = exports.getISOTimestamp = exports.getUniqueIdentifierStr = exports.triggerPixel = exports.createTrackPixelIframeHtml = exports.insertUserSyncIframe = exports.insertHtmlIntoIframe = exports.createInvisibleIframe = exports.waitForElementToLoad = exports.insertElement = exports.deepCopy = exports.insertStyleSheet = exports.normalizeObjectKeys = exports.normalizeString = exports.fetchWithTimeout = exports.generateRandomString = exports.isEmptyStr = exports.isEmpty = exports.isBoolean = exports.isPlainObject = exports.isNumber = exports.isArray = exports.isStr = exports.isFn = exports.isA = exports.deepAccess = exports.mergeDeep = exports.deepEqual = exports.getBrowserLanguage = exports.getDNT = exports.getPageHeight = exports.getPageWidth = exports.getURLSearchParam = exports.getDomain = exports.getReferrer = exports.getURL = exports.parseURL = exports.getUserAgent = exports.checkIsBot = exports.generateUUID = exports.deepMerge = exports.deepSetValue = void 0;
var uuid_1 = require("uuid");
var deepmerge_1 = __importDefault(require("deepmerge"));
exports.deepMerge = deepmerge_1.default;
var log_1 = require("./log");
var isbot_1 = require("isbot");
var dset_1 = require("dset");
Object.defineProperty(exports, "deepSetValue", { enumerable: true, get: function () { return dset_1.dset; } });
function generateUUID() {
    return (0, uuid_1.v4)();
}
exports.generateUUID = generateUUID;
function checkIsBot() {
    return (0, isbot_1.isbot)(navigator.userAgent);
}
exports.checkIsBot = checkIsBot;
/**
 * Function to get User Agent
 */
function getUserAgent() {
    return navigator.userAgent || '';
}
exports.getUserAgent = getUserAgent;
/**
 * @param {string} url
 * @returns {URL | undefined}
 * @description Parse URL string into URL object
 */
function parseURL(url) {
    var parsedURL;
    if (url) {
        parsedURL = new URL(url);
    }
    return parsedURL;
}
exports.parseURL = parseURL;
/**
 *
 * @returns {URL | undefined}
 * @description Get URL object from window.location.href
 */
function getURL() {
    return parseURL(window.location.href);
}
exports.getURL = getURL;
/**
 *
 * @returns {URL | undefined}
 * @description Get URL object from document.referrer
 */
function getReferrer() {
    return parseURL(document.referrer);
}
exports.getReferrer = getReferrer;
/**
 *
 * @returns {string | undefined}
 * @description Get domain from window.location.href
 */
function getDomain() {
    var url = getURL();
    if (url) {
        return url.hostname;
    }
}
exports.getDomain = getDomain;
/**
 *
 * @returns {string | undefined}
 * @description Get domain from document.referrer
 */
function getURLSearchParam(param) {
    var url = getURL();
    if (url) {
        return url.searchParams.get(param) || undefined;
    }
}
exports.getURLSearchParam = getURLSearchParam;
/**
 *
 * @returns {string | undefined}
 * @description Get domain from document.referrer
 */
function getPageWidth() {
    return window.innerWidth;
}
exports.getPageWidth = getPageWidth;
/**
 *
 * @returns {string | undefined}
 * @description Get domain from document.referrer
 */
function getPageHeight() {
    return window.innerHeight;
}
exports.getPageHeight = getPageHeight;
/**
 * Function to get DNT
 */
function getDNT() {
    return navigator.doNotTrack || 0;
}
exports.getDNT = getDNT;
/**
 * Browser language using ISO-639-1-alpha-2
 * @returns {string | undefined}
 * @description Get browser language
 * @see https://www.w3schools.com/tags/ref_language_codes.asp
 * @see https://www.metamodpro.com/browser-language-codes
 */
function getBrowserLanguage() {
    try {
        return (navigator.language || '').split('-')[0];
    }
    catch (e) {
        return '';
    }
}
exports.getBrowserLanguage = getBrowserLanguage;
/**
 * This function deeply compares two objects checking for their equivalence.
 * @param {Object} obj1
 * @param {Object} obj2
 * @param checkTypes {boolean} if set, two objects with identical properties but different constructors will *not*
 * be considered equivalent.
 * @returns {boolean}
 */
function deepEqual(obj1, obj2, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.checkTypes, checkTypes = _c === void 0 ? false : _c;
    if (obj1 === obj2)
        return true;
    else if ((typeof obj1 === 'object' && obj1 !== null) &&
        (typeof obj2 === 'object' && obj2 !== null) &&
        (!checkTypes || (obj1.constructor === obj2.constructor))) {
        if (Object.keys(obj1).length !== Object.keys(obj2).length)
            return false;
        for (var prop in obj1) {
            if (Object.prototype.hasOwnProperty.call(obj2, prop)) {
                if (!deepEqual(obj1[prop], obj2[prop], { checkTypes: checkTypes })) {
                    return false;
                }
            }
            else {
                return false;
            }
        }
        return true;
    }
    else {
        return false;
    }
}
exports.deepEqual = deepEqual;
function mergeDeep(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (!sources.length)
        return target;
    var source = sources.shift();
    if (isPlainObject(target) && isPlainObject(source)) {
        var _loop_1 = function (key) {
            var _a, _b, _c;
            if (isPlainObject(source[key])) {
                if (!target[key])
                    Object.assign(target, (_a = {}, _a[key] = {}, _a));
                mergeDeep(target[key], source[key]);
            }
            else if ((0, exports.isArray)(source[key])) {
                if (!target[key]) {
                    Object.assign(target, (_b = {}, _b[key] = __spreadArray([], source[key], true), _b));
                }
                else if ((0, exports.isArray)(target[key])) {
                    source[key].forEach(function (obj) {
                        var addItFlag = 1;
                        for (var i = 0; i < target[key].length; i++) {
                            if (deepEqual(target[key][i], obj)) {
                                addItFlag = 0;
                                break;
                            }
                        }
                        if (addItFlag) {
                            target[key].push(obj);
                        }
                    });
                }
            }
            else {
                Object.assign(target, (_c = {}, _c[key] = source[key], _c));
            }
        };
        for (var key in source) {
            _loop_1(key);
        }
    }
    return mergeDeep.apply(void 0, __spreadArray([target], sources, false));
}
exports.mergeDeep = mergeDeep;
function deepAccess(obj, path) {
    // Split the path into an array of keys
    var keys = path.split('.');
    // Initialize a reference variable to the object
    var current = obj;
    // Iterate through the keys to access the nested properties
    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
        var key = keys_1[_i];
        if (current && typeof current === 'object' && key in current) {
            current = current[key];
        }
        else {
            // Return undefined if the key doesn't exist or the object is not valid
            return undefined;
        }
    }
    return current;
}
exports.deepAccess = deepAccess;
var tStr = 'String';
var tFn = 'Function';
var tNumb = 'Number';
var tObject = 'Object';
var tBoolean = 'Boolean';
var toString = Object.prototype.toString;
/**
 * Return if the object is of the
 * given type.
 * @param {*} object to test
 * @param {String} _t type string (e.g., Array)
 * @return {Boolean} if object is of type _t
 */
function isA(object, _t) {
    return toString.call(object) === '[object ' + _t + ']';
}
exports.isA = isA;
function isFn(object) {
    return isA(object, tFn);
}
exports.isFn = isFn;
function isStr(object) {
    return isA(object, tStr);
}
exports.isStr = isStr;
exports.isArray = Array.isArray.bind(Array);
function isNumber(object) {
    return isA(object, tNumb);
}
exports.isNumber = isNumber;
function isPlainObject(object) {
    return isA(object, tObject);
}
exports.isPlainObject = isPlainObject;
function isBoolean(object) {
    return isA(object, tBoolean);
}
exports.isBoolean = isBoolean;
/**
 * Return if the object is "empty";
 * this includes falsey, no keys, or no items at indices
 * @param {*} object object to test
 * @return {Boolean} if object is empty
 */
function isEmpty(object) {
    if (!object)
        return true;
    if ((0, exports.isArray)(object) || isStr(object)) {
        return !(object.length > 0);
    }
    return Object.keys(object).length <= 0;
}
exports.isEmpty = isEmpty;
/**
 * Return if string is empty, null, or undefined
 * @param str string to test
 * @returns {boolean} if string is empty
 */
function isEmptyStr(str) {
    return isStr(str) && (!str || str.length === 0);
}
exports.isEmptyStr = isEmptyStr;
/**
 * Return if object is empty, null, or undefined
 * @param obj object to test
 * @returns {boolean} if object is empty
 */
function generateRandomString(length) {
    var text = '';
    var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (var i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
exports.generateRandomString = generateRandomString;
/**
 *
 * @param url
 * @param timeout
 * @param options
 * @returns FetchResponse
 * @description Fetch with timeout
 */
function fetchWithTimeout(url, timeout, options) {
    if (timeout === void 0) { timeout = 2000; }
    if (options === void 0) { options = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var controller, id, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    controller = new AbortController();
                    id = setTimeout(function () {
                        controller.abort();
                        throw new Error('Timeout');
                    }, timeout);
                    return [4 /*yield*/, fetch(url, __assign(__assign({}, options), { signal: controller.signal }))];
                case 1:
                    response = _a.sent();
                    clearTimeout(id);
                    return [2 /*return*/, response];
            }
        });
    });
}
exports.fetchWithTimeout = fetchWithTimeout;
function normalizeString(input) {
    // Use a regular expression to remove characters that are not underscores, lowercase letters, or digits
    var normalized = input.replace(/[^A-Za-z0-9_]/g, '');
    // Convert the result to lowercase
    var lowercaseNormalized = normalized.toLowerCase();
    return lowercaseNormalized;
}
exports.normalizeString = normalizeString;
function normalizeObjectKeys(obj) {
    var normalizedObj = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            var normalizedKey = key.toLowerCase();
            normalizedObj[normalizedKey] = obj[key];
        }
    }
    return normalizedObj;
}
exports.normalizeObjectKeys = normalizeObjectKeys;
function insertStyleSheet(css) {
    var style = document.createElement('style');
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
}
exports.insertStyleSheet = insertStyleSheet;
function deepCopy(obj) {
    return JSON.parse(JSON.stringify(obj));
}
exports.deepCopy = deepCopy;
/*
* Inserts an element(elm) as targets child, by default as first child
* @param {HTMLElement} elm
* @param {HTMLElement} [doc]
* @param {HTMLElement} [target]
* @param {Boolean} [asLastChildChild]
* @return {HTML Element}
*/
function insertElement(elm, doc, target, asLastChildChild) {
    doc = doc || document;
    var parentEl;
    if (target) {
        parentEl = doc.getElementsByTagName(target);
    }
    else {
        parentEl = doc.getElementsByTagName('head');
    }
    try {
        parentEl = parentEl.length ? parentEl : doc.getElementsByTagName('body');
        if (parentEl.length) {
            parentEl = parentEl[0];
            var insertBeforeEl = asLastChildChild ? null : parentEl.firstChild;
            return parentEl.insertBefore(elm, insertBeforeEl);
        }
    }
    catch (e) {
        (0, log_1.logError)('Error inserting element', e);
    }
}
exports.insertElement = insertElement;
/**
 * Returns a promise that completes when the given element triggers a 'load' or 'error' DOM event, or when
 * `timeout` milliseconds have elapsed.
 *
 * @param {HTMLElement} element
 * @param {Number} [timeout]
 * @returns {Promise}
 */
function waitForElementToLoad(element, timeout) {
    var timer = null;
    return new Promise(function (resolve) {
        var onLoad = function () {
            element.removeEventListener('load', onLoad);
            element.removeEventListener('error', onLoad);
            if (timer != null) {
                window.clearTimeout(timer);
            }
            resolve();
        };
        element.addEventListener('load', onLoad);
        element.addEventListener('error', onLoad);
        if (timeout != null) {
            timer = window.setTimeout(onLoad, timeout);
        }
    });
}
exports.waitForElementToLoad = waitForElementToLoad;
function createInvisibleIframe() {
    var f = document.createElement('iframe');
    f.id = getUniqueIdentifierStr();
    f.height = '0';
    f.width = '0';
    // f.border = '0px';
    // f.hspace = '0';
    // f.vspace = '0';
    f.marginWidth = '0';
    f.marginHeight = '0';
    f.style.border = '0';
    f.scrolling = 'no';
    f.frameBorder = '0';
    f.src = 'about:blank';
    f.style.display = 'none';
    f.style.height = '0px';
    f.style.width = '0px';
    // f.allowtransparency = 'true';
    return f;
}
exports.createInvisibleIframe = createInvisibleIframe;
/**
 * Inserts an empty iframe with the specified `html`, primarily used for tracking purposes
 * (though could be for other purposes)
 * @param {string} htmlCode snippet of HTML code used for tracking purposes
 */
function insertHtmlIntoIframe(htmlCode) {
    if (!htmlCode) {
        return;
    }
    var iframe = createInvisibleIframe();
    insertElement(iframe, document, 'body', false);
    (function (doc) {
        doc.open();
        doc.write(htmlCode);
        doc.close();
    })(iframe.contentWindow.document);
}
exports.insertHtmlIntoIframe = insertHtmlIntoIframe;
/**
 * Inserts empty iframe with the specified `url` for cookie sync
 * @param  {string} url URL to be requested
 * @param  {string} encodeUri boolean if URL should be encoded before inserted. Defaults to true
 * @param  {function} [done] an optional exit callback, used when this usersync pixel is added during an async process
 * @param  {Number} [timeout] an optional timeout in milliseconds for the iframe to load before calling `done`
 */
function insertUserSyncIframe(url, done, timeout) {
    var iframeHtml = createTrackPixelIframeHtml(url, false, 'allow-scripts allow-same-origin');
    var div = document.createElement('div');
    div.innerHTML = iframeHtml;
    var iframe = div.firstChild;
    if (done && isFn(done)) {
        waitForElementToLoad(iframe, timeout).then(done);
    }
    insertElement(iframe, document, 'html', true);
}
exports.insertUserSyncIframe = insertUserSyncIframe;
/**
 * Creates a snippet of Iframe HTML that retrieves the specified `url`
 * @param  {string} url plain URL to be requested
 * @param  {string} encodeUri boolean if URL should be encoded before inserted. Defaults to true
 * @param  {string} sandbox string if provided the sandbox attribute will be included with the given value
 * @return {string}     HTML snippet that contains the iframe src = set to `url`
 */
function createTrackPixelIframeHtml(url, encodeUri, sandbox) {
    if (encodeUri === void 0) { encodeUri = true; }
    if (sandbox === void 0) { sandbox = ''; }
    if (!url) {
        return '';
    }
    if (encodeUri) {
        url = encodeURI(url);
    }
    if (sandbox) {
        sandbox = "sandbox=\"".concat(sandbox, "\"");
    }
    return "<iframe ".concat(sandbox, " id=\"").concat(getUniqueIdentifierStr(), "\"\n        frameborder=\"0\"\n        allowtransparency=\"true\"\n        marginheight=\"0\" marginwidth=\"0\"\n        width=\"0\" hspace=\"0\" vspace=\"0\" height=\"0\"\n        style=\"height:0px;width:0px;display:none;\"\n        scrolling=\"no\"\n        src=\"").concat(url, "\">\n        </iframe>");
}
exports.createTrackPixelIframeHtml = createTrackPixelIframeHtml;
/**
 * Inserts an image pixel with the specified `url` for cookie sync
 * @param {string} url URL string of the image pixel to load
 * @param  {function} [done] an optional exit callback, used when this usersync pixel is added during an async process
 * @param  {Number} [timeout] an optional timeout in milliseconds for the image to load before calling `done`
 */
function triggerPixel(url, done, timeout) {
    var img = new Image();
    if (done && isFn(done)) {
        waitForElementToLoad(img, timeout).then(done);
    }
    img.src = url;
}
exports.triggerPixel = triggerPixel;
/* utility method to get incremental integer starting from 1 */
var getIncrementalInteger = (function () {
    var count = 0;
    return function () {
        count++;
        return count;
    };
})();
// generate a random string (to be used as a dynamic JSONP callback)
function getUniqueIdentifierStr() {
    return getIncrementalInteger() + Math.random().toString(16).substr(2);
}
exports.getUniqueIdentifierStr = getUniqueIdentifierStr;
// Get current timestamp in utc in ISO 8601 format
function getISOTimestamp() {
    var date = new Date();
    return date.toISOString();
}
exports.getISOTimestamp = getISOTimestamp;
function validateValue(value, data_type, default_value, max) {
    if (data_type === 'string') {
        value = isStr(String(value)) ? String(value) : default_value;
        if (value.length > max) {
            value = truncateString(value, max);
        }
        if (value.length === 0) {
            value = default_value;
        }
    }
    else if (data_type === 'number') {
        value = isNumber(Number(value)) ? Number(value) : default_value;
        if (value > max) {
            value = max;
        }
    }
    else if (data_type === 'boolean') {
        value = isBoolean(Boolean(value)) ? Boolean(value) : default_value;
    }
    return value;
}
exports.validateValue = validateValue;
function truncateString(inputString, maxLength) {
    if (inputString.length > maxLength) {
        return inputString.substring(0, maxLength);
    }
    return inputString;
}
exports.truncateString = truncateString;
function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
exports.escapeRegExp = escapeRegExp;
